//@ts-nocheck
import React from "react";
import Svg from "../../Svg/Svg";
import "react-datepicker/dist/react-datepicker.css";
import OccupiedField from "../OccupiedField/OccupiedField";
import { DateFieldPicker, FieldWrapper, FieldActionWrapper, ConfirmationModal } from "@factorearth/component-library";
import { useErrorBoundary } from "react-error-boundary";
import { recordSentry } from "utils/recordSentry";

/**
 * Date Field Type.
 * @param {Object} props for the Date Field as follows
 * @param {Object} color config data
 * @param {FieldInstance} fieldInstance this field instnace
 * @param {FieldTemplate} fieldTemplate for the current fieldInstance
 * @param {String} value the current value of this field instance
 * @param {Function} handleChange callback for the controlled input
 * @param {Function} handleClickAndSubmit callback for the input onClick
 * @param {Function} onBlur callback for input onBlur
 * @param {Boolean} fromTable determines if the field is from a table or not.
 */
function DateField(props) {
	const { color, fieldInstance, fieldTemplate, value, handleChange, handleClickAndSubmit, onBlur, fromTable, username, authUsername, user, moreHorizon } =
		props;
	const [openToast, setOpenToast] = React.useState(false);
	const [toastContent, setToastContent] = React.useState({ message: "", title: "", type: "" });
	const { showBoundary } = useErrorBoundary();
	/**
	 * onBlur handler for the date field
	 * @param {Object} e event object from the input
	 */
	function handleBlur(e) {
		try {
			// Making dates timezone agnostic
			onBlur(e.target.value ? e.target.value + "T00:00:00.00" : undefined);
		} catch (error) {
			recordSentry({ error, msg: "DateField onBlur Failed" });
			showBoundary(error);
		}
	}

	function handleDateChange(e) {
		if (e.target.value === "") {
			handleChange(e);
			return;
		}
		e.target.value = e.target.value ? e.target.value + "T00:00:00.00" : undefined;
		handleChange(e);
	}

	function handleDateClickAndSubmit(e) {
		e.target.value = e.target.value ? e.target.value + "T00:00:00.00" : undefined;
		handleClickAndSubmit(e);
	}

	return (
		<>
			<ConfirmationModal
				colorPalette={color}
				details={toastContent.message}
				confirmTitle={toastContent.title}
				open={openToast}
				setOpen={setOpenToast}
				toast={toastContent.type}
				timeout={5000}
				canClose
				canMinimize
				minimized
			/>
			<FieldWrapper
				colorPalette={color}
				label={!fromTable ? fieldTemplate.header : undefined}
				link={fieldInstance.altInstanceId ? <Svg icon="LINKED" /> : undefined}
				data-fieldtemplateid={fieldTemplate.id}
				data-test="Field-Header">
				{username && username !== authUsername ? (
					<>
						<OccupiedField username={username} />
						{moreHorizon && moreHorizon}
					</>
				) : (
					<FieldActionWrapper data-test="input-wrap">
						<DateFieldPicker
							colorPalette={color}
							handleBlur={handleBlur}
							value={value.trim()}
							header={fieldTemplate.header}
							placeholder="yyyy-mm-dd"
							handleChange={handleDateChange}
							handleClickAndSubmit={handleDateClickAndSubmit}
							moreHorizon={moreHorizon ? moreHorizon : undefined}
							setOpenToast={setOpenToast}
							setToastInfo={setToastContent}
						/>
					</FieldActionWrapper>
				)}
			</FieldWrapper>
		</>
	);
}

export default DateField;
